import './controls/input.js';
import IMask from './core/holder.js';
export default IMask;
